/// <amd-module name="Wit/MarkdownEditorReduxAdapter/Redux/MarkdownEditorContracts" />

/** Redux state for markdown components */
export interface IMarkdownEditorAwareState {
    markdownStateMap: IMarkdownStateMap;
}

export type IMarkdownStateMap = { [workItemId: number]: { [fieldRefName: string]: IMarkdownEditorState } };

/** Interface used for indexing into the IMarkdownEditorAwareState */
export interface IMarkdownEditorKey {
    workItemId: number;
    fieldRefName: string;
}

export interface IMarkdownEditorState {
    editorValue: string;
    previewValue?: string;
    previewState: MarkdownPreviewState;
}

export const enum MarkdownPreviewState {
    NotAvailable = 0,
    Available,
    Error
}
